import { render, staticRenderFns } from "./ReportTableEvents.vue?vue&type=template&id=b4a7b95a"
import script from "./ReportTableEvents.vue?vue&type=script&lang=ts"
export * from "./ReportTableEvents.vue?vue&type=script&lang=ts"
import style0 from "./ReportTableEvents.vue?vue&type=style&index=0&id=b4a7b95a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports